export default "__VITE_ASSET__E08I0NYBSQBissyqM$dyHQ__"